module.exports = __webpack_public_path__ + "word_map.925633f6715929c667b2.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/img/landing/word_map.png
// module id = ../../../../../ng-src/assets/img/landing/word_map.png
// module chunks = styles